import React from "react";
import Header from "./../Common/Header";
import Footer from "./../Common/Footer";
import Banner from "./../Elements/Banner";
import AboutCompany from "../Elements/AboutCompany";
import Specialization3 from "../Elements/Specialization3";
import OurServices3 from "../Elements/OurServices3";
import OurValue3 from "../Elements/OurValue3";
import OurProject3 from "../Elements/OurProject3";
import Faq from "../Elements/Faq";
import AboutCompany6 from "./AboutCompany6";
import Specialization10 from "./Specialization10";
import OurValue9 from "./OurValue9";
import OurProject9 from "./OurProject9";
import Faq7 from "./Faq7";

var bnrimg = require("./../../images/banner/1.jpg");

class PHE extends React.Component {
  render() {
    return (
      <>
        <Header />
        <div className="page-content">
          <Banner
            title="Diversified services. Unvarying quality."
            pagename="Services"
            bgimage={bnrimg}
          />
          <AboutCompany6 />
          <Specialization10 />
          <OurValue9 />
          <OurProject9 />
          {/* <Faq7 /> */}
          <Footer />
        </div>
      </>
    );
  }
}

export default PHE;
